import axios from 'axios'
import HTTP from './http'

export default {
    getDrug: payload => axios.get(HTTP.DRUG, { params: payload }),
    getList: payload => axios.get(HTTP.DRUGS_LIST, { params: { ...payload, fromAdminPanel: true } }),
    updateDrug: payload => axios.put(HTTP.DRUG, { ...payload }),
    addFamily: payload => axios.post(HTTP.DRUGS_ADD_FAMILY, { payload }),
    dltFamily: id => axios.post(HTTP.DRUGS_DLT_FAMILY, { id }),
    dltRelation: payload => axios.post(HTTP.DRUGS_DLT_RELATION, { payload }),
    addRelation: payload => axios.post(HTTP.DRUGS_ADD_RELATION, { payload })
}
